export default {
  overviewTitle: 'Voertuigen',
  detailTitle: 'Voertuig',
  deleteTitle: 'dit voertuig',
  url: '/vehicle/vehicles',
  apiUrl: '/vehicles/',
  sortBy: ['nr'],
  sortDesc: [false],
  deletable: false,
  editable: true,
  filterName: 'vehicle/vehicles',
  defaultPerPage: 100,
  quickFilter: {
    text: 'Zoek op nr',
    value: 'nr',
    type: 'text'
  },
  advancedSearchFields: [
    {text: 'Keuring vervalt binnen', value: 'inspection_expires_in', suffix: 'dag(en)'},
    {text: 'Tacho vervalt binnen', value: 'vignette_expires_in', suffix: 'dag(en)'}
  ],
  newRecord: {
  },
  // isReadOnlyOverview: true,
  // customEditable(item) {
  //   return false;
  // },
  // customDeletable(item) {
  //   return false;
  // },
  tableFields: [
    {text: 'Nr', value: 'nr', link: '/vehicle/vehicles/{id}', width: '10%'},
    {text: 'Nummerplaat', value: 'licenseplate', width: '10%'},
    {text: 'Merk', value: 'make', width: '10%'},
    {text: 'Type', value: 'model', width: '10%'},
    {text: 'Aslijnen', value: 'axles', width: '2%'},
    // {text: 'Astype', value: 'axletype', width: '10%'},
    // { text: 'Massaledig', value: 'mass_empty', width: '10%'},
    // {text: 'MTTM', value: 'mttm', width: '10%'},
    // {text: 'Lengte', value: 'length', width: '10%'},
    {text: 'Category', value: 'category', width: '5%'},
    {text: 'Chassisnr', value: 'chassis_nr', width: '10%'},
    {text: 'Bouwjaar', value: 'construction_year', width: '10%', filter: 'date'},
    // {text: 'Km', value: 'km', width: '10%'},
    // {text: 'Kostprijs', value: 'cost_price', width: '10%'},
    {text: 'Keuringsdatum', value: 'inspection_date', width: '10%', filter: 'date'},
    {text: 'Tachodatum', value: 'vignette_date', width: '10%', filter: 'date'},
    // {text: 'Opmerking', value: 'remarks', width: '10%'},
    {text: 'Chauffeur', value: 'driver_full_name', width: '10%'},
    {text: 'Begeleiding', value: 'is_pilot', type: 'boolean', width: '5%'},
    {text: 'Toevoegen Werkdag', value: 'is_add_work', type: 'boolean', width: '10%'},
    {text: 'Laadplaats', value: 'load_destination', width: '10%'},
    {text: 'Losplaats', value: 'unload_destination', width: '10%'},
    {text: 'Actief', value: 'is_active', type: 'boolean', width: '10%'}
  ]
};
